import React from 'react';

export const MonthModal = {
  title: 'Month',
  body: (
    <div>
      <div>
        Valid values:
        {' '}
        <b>1 to 12</b>
      </div>
      <br />
      <p>
        The Date and Time are given in Universal Coordinated Time (also known as Greenwich Mean Time). The local date may be one day different.
      </p>
    </div>
  ),
};
